type RowObj = {
	name: [string, boolean];
	progress: string;
	quantity: number;
	date: string;
	info: boolean;
};

const tableDataCheck: RowObj[] = [
	{
		name: [ 'Lorem Ipsum dot amet', true ],
		quantity: 2458,
		progress: '17.5%',
		date: '12 Jan 2023',
		info: true
	},
	{
		name: [ 'Lorem Ipsum dot amet', true ],
		quantity: 1485,
		progress: '10.8%',
		date: '21 Fev 2023',
		info: true
	},
	{
		name: [ 'Lorem Ipsum dot amet', true ],
		quantity: 1024,
		progress: '21.3%',
		date: '13 Mar 2023',
		info: true
	},
	{
		name: [ 'Lorem Ipsum dot amett', true ],
		quantity: 858,
		progress: '31.5%',
		date: '24 Jan 2023',
		info: true
	},
	{
		name: [ 'Lorem Ipsum dot amet', true ],
		quantity: 258,
		progress: '12.2%',
		date: '24 Out 2022',
		info: true
	}
];

export default tableDataCheck;
